import * as React from 'react'
import { Layout, Menu, Row } from 'antd'
import styles from './SideBar.module.css'
import { Link, useLocation } from 'react-router-dom'
import AOI from '../../svgs/aoi'
import Site from '../../svgs/site'
import { SidebarLinks } from './constants'
import { MODULE_IDS_MAP } from '../../modules/accessControl/constants'
import useAccessControlHook from '../../modules/accessControl/accessControlHook'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
// const { SubMenu } = Menu;
const { Sider } = Layout

interface ISideBarProps {
  isActive: boolean
  isCollapsed: boolean
  onCollapse: () => void
}

const SideBar: React.FunctionComponent<ISideBarProps> = (props) => {
  const { pathname } = useLocation()
  const { hasPermissions } = useAccessControlHook(MODULE_IDS_MAP.aoiModule)

  const selectedMenuLinks = React.useMemo(() => {
    return SidebarLinks.filter((link) => pathname.includes(link.name)).map((link) => link.key)
  }, [pathname])

  return (
    <Sider
      className={styles.sider}
      collapsible
      collapsed={props.isCollapsed}
      onCollapse={props.onCollapse}
      collapsedWidth={60}
      width={props.isCollapsed ? 60 : 150}
      trigger={
        props.isCollapsed ? (
          <MenuUnfoldOutlined className={styles.trigger} />
        ) : (
          <MenuFoldOutlined className={styles.trigger} />
        )
      }>
      <div className={styles.logo}>Lattice</div>
      <Menu
        theme="dark"
        defaultSelectedKeys={[...selectedMenuLinks]}
        className={styles.menu}
        mode="inline"
        selectedKeys={[...selectedMenuLinks]}>
        {/* <Menu.Item key="1" title="Organization">
          <Link to="/organization">
            <HomeOutlined />
            {!collapsed ? <span> Organization</span> : null}
          </Link>
        </Menu.Item> */}
        {hasPermissions > 0 && (
          <Menu.Item key="2" title="AOI" className={styles.menuItem}>
            <Link to="/aoi">
              <Row align="middle" className={styles.menuItemRow}>
                <AOI />
                {!props.isCollapsed ? <span className={styles.menuItemText}> AOI</span> : null}
              </Row>
            </Link>
          </Menu.Item>
        )}
        <Menu.Item key="3" title="Site" className={styles.menuItem}>
          <Link to="/site">
            <Row align="middle" className={styles.menuItemRow}>
              <Site />
              {!props.isCollapsed ? <span className={styles.menuItemText}> Site</span> : null}
            </Row>
          </Link>
        </Menu.Item>
        {/* <Menu.Item key="4" title="QGIS">
          <Link to="/qgis">
            <DesktopOutlined />
            {!collapsed ? <span> QGis</span> : null}
          </Link>
        </Menu.Item> */}
        {/* <SubMenu
        key="sub1"
        title={<span><UserOutlined /><span>User</span></span>}
      >
        <Menu.Item key="3">Tom</Menu.Item>
        <Menu.Item key="4">Bill</Menu.Item>
        <Menu.Item key="5">Alex</Menu.Item>
      </SubMenu> */}
      </Menu>
    </Sider>
  )
}

export default SideBar
